import * as Yup from "yup";
import { countriesCode } from "../../../constants/countriesCode";

export const defaultValues = {
  name: null,
  surname: null,
  email: null,
  phone: "",
  country: "",
  roles: null,
};

export const schema = Yup.object().shape({
  name: Yup.string()
    .required("Merchant name is required")
    .max(100, "Merchant name is too long, should be less than 100 characters"),
  surname: Yup.string()
    .required("Surname is required")
    .max(100, "Surname is too long, should be under 100 characters"),
  email: Yup.string().required("Email is required"),
  phone: Yup.string()
    .trim()
    .nullable()
    .max(100, "Phone number is too long, should be less than 100 characters"),
  country: Yup.string()
    .nullable()
    .oneOf(["", ...countriesCode.map((option) => option.code)], "Select a country code")
    .when("phone", {
      is: (phone) => Boolean(phone?.trim()),
      then: (field) => field.required("Select a country code"),
    }),
  roles: Yup.array().of(Yup.string()).required("Role is required"),
});

/** Omits an empty phone and combines a provided number with its selected country dial code. */
export const sanitizeRequest = ({ country, phone, ...user }) => {
  if (!phone?.trim()) return user;

  const dialCode = countriesCode.find((option) => option.code === country).phone;
  return { ...user, phone: `+${dialCode.replace(/-/g, "")}${phone.trim()}` };
};
